import { render, staticRenderFns } from "./SuperAmbassador.vue?vue&type=template&id=5eae0bc3"
import script from "./SuperAmbassador.vue?vue&type=script&lang=js"
export * from "./SuperAmbassador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports